import React from 'react';
import { createRoot } from 'react-dom/client';
import '../index.css';
import Constituo from './Constituo.jsx';
import { SingletonHooksContainer } from 'react-singleton-hook';

    const app = (
        <>
          <SingletonHooksContainer/>
          <Constituo />
        </>
    );

	const root = createRoot(document.getElementById('constituo-imaging-container'));
	root.render(app);

